
const features = [
    {
        title: 'carRental',
        image: 'assets/img/features/1.svg',
    },
    {
        title: 'allInclusive',
        image: 'assets/img/features/2.svg',
    },
    {
        title: 'airConditioned',
        image: 'assets/img/features/3.svg',
    },
    {
        title: 'underProtection',
        image: 'assets/img/features/4.svg',
    },
    {
        title: 'freeTelephone',
        image: 'assets/img/features/10.svg',
    },
    {
        title: 'freeWifi',
        image: 'assets/img/features/6.svg',
    },
    {
        title: 'smartTV',
        image: 'assets/img/features/7.svg',
    },
    {
        title: 'laundry',
        image: 'assets/img/features/8.svg',
    },
]
export default features